import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Index from './pages/Index';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ShippingPolicy from './pages/ShippingPolicy';
import ReturnPolicy from './pages/ReturnPolicy';
import Products from './pages/Products';
import FAQ from './pages/FAQ';
import BlogIndex from './pages/blog/index';
import MarineFuelEfficiency from './pages/blog/MarineFuelEfficiency';
import WinterizeBoatEngine from './pages/blog/WinterizeBoatEngine';
import EthanolInMarineFuel from './pages/blog/EthanolInMarineFuel';
import CarbonDepositsMarineEngine from './pages/blog/CarbonDepositsMarineEngine';
import MarineFuelContamination from './pages/blog/MarineFuelContamination';
import MarineEnginePerformance from './pages/blog/MarineEnginePerformance';
import { StructuredData } from './components/SEO/StructuredData';
import { Helmet } from 'react-helmet-async';
import Breadcrumbs from './components/Breadcrumbs';

function App() {
  const siteUrl = 'https://marinefuelboost.com';
  const title = 'Marine Fuel Boost | Premium Marine Fuel Solutions for Optimal Engine Performance';
  const description = 'Discover premium marine fuel additives that protect your engine, improve performance, and extend time on the water. Expert-formulated solutions for marine engines. Shop now & boost your boat\'s efficiency!';
  
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href={siteUrl} />
        
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={`${siteUrl}/images/fuel-dx-logo.png`} />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={`${siteUrl}/images/fuel-dx-logo.png`} />
      </Helmet>

      <StructuredData
        title={title}
        description={description}
        imageUrl={`${siteUrl}/images/fuel-dx-logo.png`}
        url={siteUrl}
      />

      <Toaster position="top-right" />
      <div className="min-h-screen bg-white text-gray-900 flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Breadcrumbs />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/products" element={<Products />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/return-policy" element={<ReturnPolicy />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/marine-fuel-efficiency" element={<MarineFuelEfficiency />} />
            <Route path="/blog/winterize-boat-engine" element={<WinterizeBoatEngine />} />
            <Route path="/blog/ethanol-in-marine-fuel" element={<EthanolInMarineFuel />} />
            <Route path="/blog/carbon-deposits-marine-engine" element={<CarbonDepositsMarineEngine />} />
            <Route path="/blog/marine-fuel-contamination" element={<MarineFuelContamination />} />
            <Route path="/blog/marine-engine-performance" element={<MarineEnginePerformance />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
